// Normalize article content for rendering and block-based features
// Currently strips image-cache comments (<!-- original: ... -->) so that
// Reader and TranslationContext see identical text when computing blocks.

// KaTeX does not treat `_` as a literal character inside \text{} — it still
// parses it as a subscript operator, causing ParseError. Mathpix commonly
// emits identifiers like \text { step_num } and \text { warmup_steps }.
// This function escapes bare underscores inside \text (and \textit, \textbf, etc.)
// to \_ so KaTeX renders them correctly as literal underscores.
function sanitizeLatexForKatex(content) {
  return content.replace(/\\(text[a-z]*)\s*\{([^{}]*)\}/g, (match, cmd, inner) => {
    const fixed = inner.replace(/(?<!\\)_/g, '\\_');
    return `\\${cmd}{${fixed}}`;
  });
}

export function getRenderableContent(raw) {
  if (!raw) return '';
  // Remove cached-image "original" comments plus trailing newline, if any
  let content = raw.replace(/<!--\s*original:\s*[^>]+-->\n?/g, '');
  // Fix Mathpix-generated LaTeX: escape bare underscores inside \text{} variants
  content = sanitizeLatexForKatex(content);
  return content;
}
